const SavingsPolicyOptions =[
  {type: "regular", longName: "Regular Savings Account", imageUrl: "regularSavings.png", 
        shortName: "Regular Savings", sortValue: "a",
        taxExempt: false, term: "short", savingsClass: "bank", sortNbr: 10,
        featuresArr: ["Compound Interest", "Unlimited Withdrawals", "Auto-Deposit"],
        description:  "A basic interest-earning account that helps you grow your " +
            "money while keeping it easily accessible. Ideal for emergency funds or " +
            "short-term saving goals."
  },
  {type: "CD", longName: "Certificate of Deposit", imageUrl: "CD.png",
        shortName: "Certificate of Deposit", sortValue: "b",
        taxExempt: false, term: "long", savingsClass: "bank", sortNbr: 20,
        featuresArr: ["1-year Term", "Deposit Increments of $1000", "Earn Interest", "Auto-Rollover Option" ],
        description:  "A time-based deposit that earns a fixed interest rate for a set period. " +
            "Withdrawals before the maturity date will result in penalties."
  },
  {type: "highYield", longName: "High Yield Savings Account", imageUrl: "highYield.png",
        shortName: "High Yield Savings", sortValue: "c",
        taxExempt: false, term: "short", savingsClass: "bank", sortNbr: 30,
        featuresArr: ["Compound Interest", "Unlimited withdrawals", "Auto-Deposit"],
        description: "A savings account that typically offers higher interest rates than regular savings, " +
            "with unlimited monthly withdrawals. Does not include check-writing or debit card access."
  },
  {type: "Conservative", longName: "401(k) Account - Conservative", imageUrl: "conservative.png",
        shortName: "401(k) - Conservative", sortValue: "d",
        taxExempt: true, term: "long", savingsClass: "retirement", sortNbr: 50,
        featuresArr: ["Company Match!!", "Fees Charged for Any Withdrawals before retirement", "Auto-Deposit"],
        description: "This option focuses on safety. Your money is invested in government and corporate bonds " +
            "that are expected to be low-risk, meaning you're less likely to lose money — but the returns are " +
            "smaller too. It's a steady, slow-growing option that protects your savings from big market swings. " +
            "Good if you want to play it safe. "
    },
    {type: "Balanced", longName: "401(k) Account - Balanced", imageUrl: "balanced.png",
        shortName: "401(k) - Balanced", sortValue: "e",
        taxExempt: true, term: "long", savingsClass: "retirement", sortNbr: 60,
        featuresArr: ["Company Match!!", "Fees Charged for Any Withdrawals before retirement", "Auto-Deposit"],
        description: "This fund aims for a steady mix of growth and safety. It invests in both stocks and bonds " +
            "so it's not too risky, not too conservative. The balance stays about the same over time, so you always " +
            "have some potential for gains and some protection from losses. It’s a solid middle-ground option " +
            "if you want to grow your money without taking big risks."
    },
    {type: "Aggressive", longName: "401(k) Account - Aggressive", imageUrl: "aggressive.png",
        shortName: "401(k) - Aggressive", sortValue: "f",
        taxExempt: true, term: "long", savingsClass: "retirement", sortNbr: 70,
        featuresArr: ["Company Match!!", "Fees Charged for Any Withdrawals before retirement", "Auto-Deposit"],
        description: "This option invests your money in the stock market, aiming for high growth over time. " +
            "It has the potential for bigger returns, but also comes with more risk — your balance can go up " +
            "and down a lot. It’s best if you’re thinking long-term and can handle a few bumps along the way. " +
            "Bigger risk, bigger reward. "
    }
]
export default SavingsPolicyOptions;